import { render, staticRenderFns } from "./ProjectTemplatesDialog.vue?vue&type=template&id=23357056&"
import script from "./ProjectTemplatesDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplatesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports